import * as React from 'react';
import { SearchResultList } from '../../components/SearchResultList';
import { SearchResultItemContainer } from '../SearchResultItem';
import { useSelector } from 'react-redux';
import { selectBuilders } from '../../selectors/builders';
import { selectLoading } from '../../selectors/loading';
import { Preloader } from '../../components/Preloader';
import { SearchResultPlug } from '../../components/SearchResultPlug';
import { UXFB_SCROLL_DEVELOPER_CATALOG_COUNT } from '../../constants/uxfb';
import { ScrollDeveloperCatalogUxfbTracker } from './ScrollDeveloperCatalogUxfbTracker';

export function SearchResultContainer(): React.JSX.Element {
  const builders = useSelector(selectBuilders);
  const loading = useSelector(selectLoading);

  return (
    <SearchResultList loader={loading && <Preloader size={40} />} plug={!builders.length && <SearchResultPlug />}>
      {builders.map((builder, index) => (
        <React.Fragment key={builder.id}>
          <SearchResultItemContainer builder={builder} />
          {index === UXFB_SCROLL_DEVELOPER_CATALOG_COUNT - 1 && <ScrollDeveloperCatalogUxfbTracker />}
        </React.Fragment>
      ))}
    </SearchResultList>
  );
}
